module.exports = __webpack_public_path__ + "static/media/notification.e2242af6.svg";